import { Component } from '@angular/core';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '../../components/button/button.component';
import { NgFor, NgIf } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { FormSectionComponent } from '../../components/form-section/form-section.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { GlobalService } from '../../services/global.service';
import { ValidationService } from '../../services/validation.service';


@Component({
  selector: 'app-role-permission-form-page',
  imports: [SelectInputComponent, TextInputComponent, ReactiveFormsModule, FormsModule, ButtonComponent, NgFor, NgIf, HeaderComponent, FormSectionComponent],
  templateUrl: './role-permission-form-page.component.html',
  styleUrl: './role-permission-form-page.component.css'
})
export class RolePermissionFormPageComponent {

  form: FormGroup;
  params: any = {};
  access: any = [{ title: 'All Access', value: 'all' }, { title: 'School', value: 'university' }, { title: 'School Branch', value: 'college' }, { title: 'Subject', value: 'subject' }]
  landing_page_options: any = [
    { title: 'Dashboard', value: '/dashboard' },
    { title: 'User List', value: '/user/list' },
    { title: 'Student List', value: '/user/student-list' },
    { title: 'School List', value: '/university/list' },
    { title: 'School Branch List', value: '/college/list' },
    { title: 'Course List', value: '/course/list' },
    { title: 'Academic Year List', value: '/academic-year/list' },
    { title: 'Exam List', value: '/exam/list' },
    { title: 'Assessment List', value: '/assessment/list' },
    { title: 'Script List', value: '/add-script/list' },
    { title: 'Barcode Mapping', value: '/barcode-mapping/list' },
    { title: 'Evaluator Mapping', value: '/evaluator-mapping/list' },
    { title: 'Exam Results', value: '/exam-result/list' },
    { title: 'Exam Results (Student)', value: '/student-portal/list' },
    { title: 'Role List', value: '/role/list' },
  ];
  isSubmitting = false;

  sections = [
    {
      name: 'Dashboard',
      toggle: false,
      actions: ['View', 'Download', 'Select All']
    },
    {
      name: 'Masters',
      toggle: false,
      sub_sections: [
        { name: 'Location', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'University', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'College', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'Course', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
      ]
    },
    {
      name: 'Evaluation Management',
      toggle: false,
      sub_sections: [
        { name: 'Academic Year', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'Examinations', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'Assessments', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
      ]
    },
    {
      name: 'User Management',
      toggle: false,
      sub_sections: [
        { name: 'Faculty', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'Students', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'RBAC', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
      ]
    },
    {
      name: 'Script Management',
      toggle: false,
      sub_sections: [
        { name: 'Barcode Mapping', actions: ['View', 'Map', 'Update', 'Delete', 'Disable', 'Select All'] },
        { name: 'Scripts', actions: ['View', 'Add', 'Update', 'Delete', 'Disable', 'Select All'] },
      ]
    },
    {
      name: 'Assignments',
      toggle: false,
      sub_sections: [
        { name: 'Assign Evaluation', actions: ['View', 'Assign', 'Update', 'Select All'] },
        { name: 'Assign Re_evaluation', actions: ['View', 'Assign', 'Update', 'Select All'] },
      ]
    },
    {
      name: 'Evaluations and Revaluations',
      toggle: false,
      sub_sections: [
        { name: 'Evaluation', actions: ['View', 'Assign', 'Update', 'Select All'] },
        { name: 'Head Evaluation', actions: ['View', 'Assign', 'Update', 'Select All'] },
      ]
    },
    {
      name: 'Exam Results',
      toggle: false,
      sub_sections: [
        { name: 'Exam Results', actions: ['View', 'Release', 'Select All'] },
      ]
    },
    {
      name: 'Login Verification',
      toggle: false,
      sub_sections: [
        { name: 'Login Verification', actions: ['View', 'Approve', 'Select All'] },
      ]
    },
    {
      name: 'AI Settings',
      toggle: false,
      sub_sections: [
        { name: 'AI Settings', actions: ['AI Verification', 'AI Evaluation', 'Select All'] },
      ]
    },
    {
      name: 'Notifications',
      toggle: false,
      sub_sections: []
    }
  ];


  constructor(private fb: FormBuilder, public ar: ActivatedRoute, public role: RoleService, public route: Router, public gs: GlobalService, public vs: ValidationService) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(this.vs.new_name_pattern), Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name)]],
      belongs_to: ['', [Validators.required]],
      landing_page: ['/dashboard'],
      permissions: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      if (this.params.id) {
        this.patch_form_data(this.params.id)
      }
    })
    this.build_permissions();
  }

  get permissions_FA(): FormArray {
    return this.form.get('permissions') as FormArray;
  }
  get_sub_sections(section: AbstractControl): FormArray {
    return section.get('sub_sections') as FormArray;
  }

  get_actions(control: AbstractControl): FormArray {
    return control.get('actions') as FormArray;
  }

  build_permissions() {
    this.sections.forEach((section: any) => {

      const section_group = this.fb.group({
        section: [section.name],
        toggle: [section.toggle],
        actions: this.fb.array([]),
        sub_sections: this.fb.array([])
      });
      if (!section?.sub_sections?.length) {
        section?.actions?.forEach((action: any) => {
          (section_group.get('actions') as FormArray).push(
            this.fb.group({
              name: [action],
              value: [false]
            })
          );
        });
      }
      section?.sub_sections?.forEach((sub: any) => {
        const sub_group = this.fb.group({
          name: [sub.name],
          actions: this.fb.array([])
        });

        sub.actions.forEach((action: any) => {
          (sub_group.get('actions') as FormArray).push(
            this.fb.group({
              name: [action],
              value: [false]
            })
          );
        });

        (section_group.get('sub_sections') as FormArray).push(sub_group);
      });

      this.permissions_FA.push(section_group);
    });
  }

  on_section_toggle(section: AbstractControl) {
    const toggle = section.get('toggle')?.value;

    if (!toggle) {
      const actions = section.get('actions') as FormArray;
      if (actions) {
        actions.controls.forEach(act => act.get('value')?.setValue(false));
      }
      const sub_sections = section.get('sub_sections') as FormArray;
      if (sub_sections) {
        sub_sections.controls.forEach(sub => {
          const sub_actions = sub.get('actions') as FormArray;
          if (sub_actions) {
            sub_actions.controls.forEach(a => a.get('value')?.setValue(false));
          }
        });
      }
    }
  }

  on_action_change(section: AbstractControl, sub: AbstractControl | null, act_index: number) {
    let actions_fa: FormArray;

    if (sub) {
      actions_fa = sub.get('actions') as FormArray;
    } else {
      actions_fa = section.get('actions') as FormArray;
    }

    const clicked = actions_fa.at(act_index);
    const name = clicked.get('name')?.value;
    const value = clicked.get('value')?.value;

    if (name === 'Select All') {
      actions_fa.controls.forEach(ctrl => {
        if (ctrl.get('name')?.value !== 'Select All') {
          ctrl.get('value')?.setValue(value);
        }
      });
      return;
    }

    if (name !== 'View' && value === true) {
      const viewCtrl = actions_fa.controls.find(
        c => c.get('name')?.value === 'View'
      );
      if (viewCtrl) {
        viewCtrl.get('value')?.setValue(true, { emitEvent: false });
      }
    }

    const allChecked = actions_fa.controls
      .filter(c => c.get('name')?.value !== 'Select All')
      .every(c => c.get('value')?.value === true);

    const selectAllCtrl = actions_fa.controls.find(
      c => c.get('name')?.value === 'Select All'
    );

    if (selectAllCtrl) {
      selectAllCtrl.get('value')?.setValue(allChecked, { emitEvent: false });
    }
  }

  //   on_action_change(section: AbstractControl, sub: AbstractControl | null, act_index: number) {
  //   const actions_fa: FormArray = sub
  //     ? (sub.get('actions') as FormArray)
  //     : (section.get('actions') as FormArray);

  //   const clicked = actions_fa.at(act_index);
  //   const name = clicked.get('name')?.value;
  //   if (name === 'Select All') {
  //     const value = clicked.get('value')?.value;
  //     actions_fa.controls.forEach(ctrl => {
  //       if (ctrl.get('name')?.value !== 'Select All') {
  //         ctrl.get('value')?.setValue(value);
  //       }
  //     });
  //     return;
  //   }

  //   const viewCtrl = actions_fa.controls.find(
  //     c => c.get('name')?.value === 'View'
  //   );

  //   const nonViewActions = actions_fa.controls.filter(
  //     c =>
  //       c.get('name')?.value !== 'View' &&
  //       c.get('name')?.value !== 'Select All'
  //   );

  //   const anyNonViewSelected = nonViewActions.some(
  //     c => c.get('value')?.value === true
  //   );

  //   if (viewCtrl) {
  //     if (anyNonViewSelected) {
  //       viewCtrl.get('value')?.setValue(true, { emitEvent: false });
  //       viewCtrl.disable({ emitEvent: false });
  //     } else {
  //       viewCtrl.enable({ emitEvent: false });
  //     }
  //   }

  //   const allChecked = actions_fa.controls
  //     .filter(c => c.get('name')?.value !== 'Select All')
  //     .every(c => c.get('value')?.value === true);

  //   const selectAllCtrl = actions_fa.controls.find(
  //     c => c.get('name')?.value === 'Select All'
  //   );

  //   if (selectAllCtrl) {
  //     selectAllCtrl.get('value')?.setValue(allChecked, { emitEvent: false });
  //   }
  // }


  logPermissionsToConsole() {
    const formValue = this.form.value;
    const output: any = {
      name: formValue.name,
      belongs_to: formValue.belongs_to,
      landing_page: formValue.landing_page
    };

    formValue.permissions.forEach((section: any) => {
      const sectionKey = section.section.replace(/\s+/g, '_').toLowerCase();

      // Section-level toggle key
      output[`${sectionKey}_permission`] = !!section.toggle;

      // Section-level actions
      section.actions.forEach((action: any) => {
        if (action.name !== 'Select All') {
          const actionKey = action.name.replace(/\s+/g, '_').toLowerCase();
          output[`${sectionKey}_${actionKey}`] = !!action.value;
        }
      });

      // Sub-sections
      section.sub_sections.forEach((sub: any) => {
        const subKey = sub.name.replace(/\s+/g, '_').toLowerCase();
        sub.actions.forEach((action: any) => {
          if (action.name !== 'Select All') {
            const actionKey = action.name.replace(/\s+/g, '_').toLowerCase();
            output[`${sectionKey}_${subKey}_${actionKey}`] = !!action.value;
          }
        });
      });
    });

    console.log(output);
    return output
  }

  sync_select_all(actions_fa: FormArray) {
    if (!actions_fa || actions_fa.length === 0) return;
    const selectAllCtrl = actions_fa.controls.find(c => c.get('name')?.value === 'Select All');
    if (!selectAllCtrl) return;
    const allChecked = actions_fa.controls
      .filter(c => c.get('name')?.value !== 'Select All')
      .every(c => c.get('value')?.value === true);
    selectAllCtrl.get('value')?.setValue(allChecked, { emitEvent: false });
  }

  async patch_form_data(id: any) {
    try {
      const response = await this.role.get(id);
      const data = response.data;

      // patch simple fields
      this.form.patchValue({
        name: data.name,
        belongs_to: data.belongs_to,
        landing_page: data.landing_page || '/dashboard'
      });

      // patch permissions
      this.permissions_FA.controls.forEach((sectionCtrl: AbstractControl) => {

        const sectionName = sectionCtrl.get('section')?.value;
        const sectionKey = sectionName.replace(/\s+/g, '_').toLowerCase();

        // section toggle
        const permissionKey = `${sectionKey}_permission`;
        if (permissionKey in data) {
          sectionCtrl.get('toggle')?.setValue(!!data[permissionKey]);
        }

        // section level actions (Dashboard etc.)
        const sectionActions = sectionCtrl.get('actions') as FormArray;
        sectionActions?.controls.forEach(actionCtrl => {
          const actionName = actionCtrl.get('name')?.value;
          if (actionName !== 'Select All') {
            const actionKey =
              `${sectionKey}_${actionName.replace(/\s+/g, '_').toLowerCase()}`;
            if (actionKey in data) {
              actionCtrl.get('value')?.setValue(!!data[actionKey]);
            }
          }
        });
        this.sync_select_all(sectionActions);

        // sub sections
        const subSections = sectionCtrl.get('sub_sections') as FormArray;
        subSections?.controls.forEach(subCtrl => {
          const subName = subCtrl.get('name')?.value;
          const subKey = subName.replace(/\s+/g, '_').toLowerCase();

          const subActions = subCtrl.get('actions') as FormArray;
          subActions.controls.forEach(actionCtrl => {
            const actionName = actionCtrl.get('name')?.value;
            if (actionName !== 'Select All') {
              const actionKey =
                `${sectionKey}_${subKey}_${actionName.replace(/\s+/g, '_').toLowerCase()}`;
              if (actionKey in data) {
                actionCtrl.get('value')?.setValue(!!data[actionKey]);
              }
            }
          });
          this.sync_select_all(subActions);
        });
      });

    } catch (error) {
      console.error(error);
    }
  }



  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.logPermissionsToConsole()
      console.log(form_value, 'lllllll');

      // return
      if (this.params.id) {
        let update_response = await this.role.update(this.params.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.role.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.route.navigate(['/role/list'])
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
}

